






























import BaseComponent from '@/components/base-component.vue';
import IClient from '@/interfaces/client';
import * as service from '@/services/clients';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class UiSelectClients extends BaseComponent {
  @Prop(String)
  public label!: string;
  @Prop()
  public value!: any[];
  @Prop()
  public suffix?: string;
  @Prop()
  public placeholder?: string;
  @Prop()
  public height?: string;
  @Prop()
  public singleLine?: boolean;
  @Prop()
  public outline?: boolean;
  @Prop()
  public required?: boolean;
  @Prop()
  public hideDetails?: boolean;
  @Prop()
  public disabled?: boolean;
  @Prop()
  public rules?: any[];
  @Prop()
  public multiple?: boolean;
  @Prop()
  public chips?: boolean;
  @Prop()
  public clearable?: boolean;
  @Prop()
  public deletableChips?: boolean;

  @Prop({default: false})
  public showCodProtheus?: boolean;

  @Prop()
  public hint?: string;

  @Prop({default: false})
  public persistentHint?: boolean;

  public attr = {
    suffix: '',
    label: 'Clientes',
    placeholder: '',
    height: '',
    singleLine: false,
    outline: false,
    hideDetails: false,
    disabled: false,
    required: false,
    rules: [],
    multiple: true,
    chips: true,
    clearable: true,
    deletableChips: true,
  };

  public selectedClient: string = '';

  private clients: IClient[] = [];
  private clientsList: IClient[] = [];

  loading = false;

  @Watch('value')
  public onValChanged(val: IClient[]): void {
    this.clients = val;
  }

  public beforeMount(): void {
    this.attr.label = this.label || this.attr.label;
    this.attr.suffix = this.suffix || this.attr.suffix;
    this.attr.placeholder = this.placeholder || this.attr.placeholder;
    this.attr.height = this.height || this.attr.height;
    this.attr.singleLine =
      typeof this.singleLine !== 'undefined' || this.attr.singleLine;
    this.attr.outline =
      typeof this.outline !== 'undefined' || this.attr.outline;
    this.attr.hideDetails =
      typeof this.hideDetails !== 'undefined' || this.attr.hideDetails;
    this.attr.disabled =
      typeof this.disabled !== 'undefined' ? this.disabled : this.attr.disabled;
    this.attr.required =
      typeof this.required !== 'undefined' || this.attr.required;
    this.attr.rules = this.rules || this.attr.rules;
    this.attr.multiple =
      typeof this.multiple !== 'undefined' ? this.multiple : this.attr.multiple;
    this.attr.chips =
      typeof this.chips !== 'undefined' ? this.chips : this.attr.chips;
    this.attr.clearable =
      typeof this.clearable !== 'undefined'
        ? this.clearable
        : this.attr.clearable;
    this.attr.deletableChips =
      typeof this.deletableChips !== 'undefined'
        ? this.deletableChips
        : this.attr.deletableChips;

    this.getClients();
  }

  public onChange(val): void {
    this.$emit('input', this.clients);
    this.$emit('change', val);
  }

  private getClients(): any {
    this.loading = true;
    service.listClients(true, []).subscribe(
      (data) => {
        this.clientsList = data;
        this.loading = false;
      },
      () => {
        this.toast.show('Ocorreu um erro ao carregar os clientes', 'error');
        this.loading = false;
      },
    );
  }

  private getItemText(i) {
    return this.showCodProtheus? this.getClientName(i) + ' - ' + i.codigoProtheus : this.getClientName(i);
  }

  private getClientName(i) {
    return i.nomeFantasia? i.nomeFantasia: i.nome;
  }
}
